import { render, staticRenderFns } from "./AddCrewSidebar.vue?vue&type=template&id=1b351ebe&scoped=true&"
import script from "./AddCrewSidebar.vue?vue&type=script&lang=js&"
export * from "./AddCrewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddCrewSidebar.vue?vue&type=style&index=0&id=1b351ebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b351ebe",
  null
  
)

export default component.exports